// Try loading as-is, fall back to alternate extension
export const imgErrorFallback = (e) => {
  const src = e.target.src;
  if (src.endsWith('.svg')) {
    e.target.src = src.replace(/\.svg$/, '.jpg');
  } else if (src.endsWith('.jpg') || src.endsWith('.jpeg')) {
    e.target.src = src.replace(/\.jpe?g$/, '.svg');
  }
};
